import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    score_flex: {
        display: "flex",
        alignItems: "baseline"
    },
    score_bold: {
        fontWeight: 600,
        fontSize: "28px", 
        paddingRight: "4px"
    },
    rectangles_scores: {
        display: "flex",
        gap: "6px",
        alignItems: "flex-end;"
      }, 
    rectangle_score: {
        width: "34px",
        height: "22px",
        opacity: "0.2",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }, 
      rectangle_score_libelle: {
        display: "none",
        color: "#7E7E8F",
        width: "50px",
        fontSize: "10px",
        fontWeight: 400,
        lineHeight: "18px",
        position: "absolute",
      },
      rectangle_score_logo: {
        width: "22px",
        height: "22px",
        display: "none",
      },
      actif: {
        position: "relative",
        "& .rectangle_score": {
            opacity: 1,
        }
      }
}));

export default useStyles;